import { call } from 'redux-saga/effects';
import { RTCClient } from 'utils/webrtc';
import { receivingPluginCleanup } from 'features/streaming/actions';

export function* onReceivingPluginCleanupSaga(action: ReturnType<typeof receivingPluginCleanup>) {
  yield call(RTCClient.receivingFeed.cleanupFeed, action.payload.instanceId);
}
